import React, { Component } from 'react';
import DragSortTable from '../../../../components/table/DragSortTable';
import { BRAND_EXPOSURE_LIST_STATUS_CLASS_NAME } from '../../../../constants/service/app/brandConstants';
import { comparePrePropsAndNextProps } from '../../../../lib/common';
import columns from './columns';
import './BrandExposureList.scss';

class BrandExposureList extends Component {
  /**
   *  Component 의 변경되는 props 와 state 가 있을 경우에만,
   *  render 메소드를 호출할 수 있도록 함
   */
  shouldComponentUpdate = (nextProps) => {
    return comparePrePropsAndNextProps([[nextProps, this.props]]);
  };

  render() {
    const {
      brandExposureList,
      setData,
      scrollToBrandElement,
      changeExposureStatus,
      changeNumberOnDragEnd,
      changeNumberOnBrandTierList,
      deleteBrandExposureItem,
    } = this.props;
    const { newList } = brandExposureList;

    return (
      <div className="brand-exposure-list">
        <DragSortTable
          className="brand-exposure-list-table"
          getProps={() => ({ id: 'store-exposure-list' })}
          emptyText="티어를 정한 브랜드가 없습니다."
          data={newList}
          onDragEnd={changeNumberOnDragEnd}
          showPagination={false}
          getTableProps={() => ({ id: 'store-exposure-list-scroll' })}
          getTdProps={(state, rowInfo) => {
            return {
              className: rowInfo ? BRAND_EXPOSURE_LIST_STATUS_CLASS_NAME[rowInfo.original.listStatus] : null,
            };
          }}
          columns={() =>
            columns({
              newList,
              setData,
              scrollToBrandElement,
              changeExposureStatus,
              changeNumberOnBrandTierList,
              deleteBrandExposureItem,
            })
          }
        />
      </div>
    );
  }
}

export default BrandExposureList;
